import { useEffect } from "react";
import { BUSINESS } from "@/data/site";

// Lightweight SEO: sets document title + meta description and injects the
// Restaurant JSON-LD structured data. Editable via props / site data.
function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} · ${BUSINESS.name}`
      : `${BUSINESS.name} | Modern Chinese Dining · Sector xxx, Gurugram`;
    document.title = fullTitle;
    if (description) setMeta("description", description);

    const ld = {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      name: BUSINESS.name,
      servesCuisine: ["Chinese", "Asian"],
      priceRange: "$$",
      telephone: BUSINESS.phoneHref,
      email: BUSINESS.email,
      address: {
        "@type": "PostalAddress",
        streetAddress: BUSINESS.addressLine1,
        addressLocality: "Gurugram",
        addressRegion: "Haryana",
        addressCountry: "IN",
      },
      openingHours: "Mo-Su 12:00-23:00",
      url: window.location.origin,
    };

    let script = document.getElementById("ld-restaurant");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "ld-restaurant";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(ld);
  }, [title, description]);

  return null;
}
